angular.module('GlobalHelpersModule').filter "state", ->
  (value, filter) ->
    matches = []
    for item in value
      if item[filter[0]] is filter[1]
        matches.push(item)
    return matches